import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getApi } from '../../../Services/apiService';
import { CheckrReportView } from '../../../LandlordComponent/PropertiesComponent/TenantDetail/BackgroundCheckReport';

export const MY_REPORT_URL = '/verification/tenant/checkr/my-report';

// The tenant's own Checkr report: for ?property_id=..., or their latest check
const MyBackgroundCheckReport = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const propertyId = searchParams.get('property_id') || '';
  const [report, setReport] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setIsLoading(true);
      try {
        const response = await getApi(MY_REPORT_URL, propertyId ? { params: { property_id: propertyId } } : {});
        if (cancelled) return;
        if (response?.statusCode === 200) {
          setReport(response?.data ?? null);
        } else {
          toast.error(response?.message || 'Failed to fetch background check report.');
        }
      } catch (error) {
        if (cancelled) return;
        console.error('Error fetching Checkr report:', error);
        toast.error(error?.response?.data?.message || 'Failed to fetch background check report. Please try again.');
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [propertyId]);

  const goBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate(propertyId ? `/tenant/properties/${propertyId}` : '/tenant/settings/background-check');
  };

  // No tenant PDF endpoint: print the report (the print styles show only the report) so it can be saved as PDF
  const handleDownload = () => {
    const previousTitle = document.title;
    document.title = 'background-check-report'; // default file name in the "Save as PDF" dialog
    window.print();
    document.title = previousTitle;
  };

  return (
    <CheckrReportView
      report={report}
      isLoading={isLoading}
      onBack={goBack}
      onDownload={handleDownload}
      isDownloading={false}
      // report is null until the check is completed
      emptyMessage="Your background check report is not ready yet."
    />
  );
};

export default MyBackgroundCheckReport;
